import { createReactRenderer } from 'helpers/react-renderer';

let RenderedComponent;

history.onChangeState(
  { name: ['item.views.item', 'item.views.quick_add'], tab: 'graphs' },
  () => {
    if (!RenderedComponent) {
      import(/* webpackChunkName: "itemchart" */ './ItemChart').then((module) => {
        RenderedComponent = createReactRenderer({
          component: module.default,
          selector: '[data-react-root="ItemChart"]',
        });
        RenderedComponent.mount();
      });
    } else {
      RenderedComponent.mount();
    }
  },
  () => {
    RenderedComponent.unmount();
  }
);
